var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFileGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0377 10.7692H2.19355C0.985454 10.7692 0 11.7547 0 12.9627V15.1563C0 15.7376 0.231621 16.2963 0.644905 16.7095C1.05364 17.1182 1.61226 17.3499 2.19354 17.3499H4.3871V67.8065C4.3871 68.3879 4.61872 68.9465 5.032 69.3552C5.44074 69.7685 5.99935 70.0001 6.58064 70.0001H52.6503C53.2316 70.0001 53.7902 69.7685 54.1989 69.3552C54.6122 68.9464 54.8438 68.3878 54.8438 67.8065V17.3499H57.0374C57.6187 17.3499 58.1773 17.1182 58.586 16.7095C58.9993 16.2962 59.2309 15.7376 59.2309 15.1563V12.9627C59.2309 12.3814 58.9993 11.8228 58.586 11.4141C58.1773 11.0008 57.6189 10.7692 57.0377 10.7692ZM48.2633 63.4198H10.9681V17.3498H48.2633V63.4198Z",
    fill: "#00FF3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5388 24.231H24.2311C25.7194 24.231 26.9234 25.4217 26.9234 26.3848V54.3849C26.9234 55.5756 25.7194 56.5387 24.2311 56.5387H21.5388C20.0504 56.5387 18.8464 55.348 18.8464 54.3849V26.3848C18.8464 25.1941 20.0505 24.231 21.5388 24.231Z",
    fill: "#00FF3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0014 24.231H37.6937C39.1821 24.231 40.386 25.4217 40.386 26.3848V54.3849C40.386 55.5756 39.182 56.5387 37.6937 56.5387H35.0014C33.513 56.5387 32.3091 55.348 32.3091 54.3849V26.3848C32.3091 25.1941 33.5131 24.231 35.0014 24.231Z",
    fill: "#00FF3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3972 0H40.8331C42.0734 0 43.0767 1.48836 43.0767 2.69231V5.38463C43.0767 6.87298 42.0734 8.07694 40.8331 8.07694H18.3972C17.1569 8.07694 16.1536 6.58858 16.1536 5.38463V2.69231C16.1536 1.20396 17.1569 0 18.3972 0Z",
    fill: "#00FF3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFileGreen);
export default __webpack_public_path__ + "static/media/remove-file-green.cdf9b9afa185f98bf19a03b5091446ad.svg";
export { ForwardRef as ReactComponent };